// removed by extract-text-webpack-plugin
module.exports = {"purchaseInfo":"purchaseInfo__purchaseInfo___2hH7J","retailer":"purchaseInfo__retailer___22_qT"};


//////////////////
// WEBPACK FOOTER
// ./src/purchases/purchaseInfo.scss
// module id = 1261
// module chunks = 0